import { __awaiter, __generator } from "tslib";
import { Fetch } from '@ekuaibao/fetch';
import { filterFromUrl as filter } from '../../lib/lib-util';
export function init() {
    return __awaiter(this, void 0, void 0, function () {
        var plateform;
        return __generator(this, function (_a) {
            plateform = filter('platform');
            if (plateform === 'DEBUGGER') {
                return [2, debuggerSession()];
            }
            if (plateform === 'DING_TALK') {
                return [2, dingTalkSession()];
            }
            if (plateform === 'WEIXIN') {
                return [2, weixinSession()];
            }
            return [2, allPlatform()];
        });
    });
}
function allPlatform() {
    return __awaiter(this, void 0, void 0, function () {
        var params, result, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    params = { accessToken: filter('token') };
                    return [4, Fetch.GET('/api/account/v2/session', params)];
                case 1:
                    result = _a.sent();
                    Fetch.isAssistPlatform = result.value && result.value.isAssistPlatform;
                    Fetch.accessToken = result.value && result.value.id;
                    Fetch.staffSetting = result.staffSetting || { language: Fetch.defaultLanguage };
                    return [2, Promise.resolve()];
                case 2:
                    e_1 = _a.sent();
                    return [2, Promise.reject({ type: 'login', msg: i18n.get('授权超时，请重新发起操作') })];
                case 3: return [2];
            }
        });
    });
}
function weixinSession() {
    return __awaiter(this, void 0, void 0, function () {
        var params, result, _a, sessionId, corporationId, staffSetting, isAssistPlatform, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    params = {
                        wxCorpId: filter('corpId'),
                        accessToken: filter('token'),
                        corpId: filter('corpId')
                    };
                    return [4, Fetch.GET('/api/qyweixin/v2/session', params)];
                case 1:
                    result = _b.sent();
                    _a = result.value, sessionId = _a.sessionId, corporationId = _a.corporationId, staffSetting = _a.staffSetting, isAssistPlatform = _a.isAssistPlatform;
                    Fetch.isAssistPlatform = isAssistPlatform;
                    Fetch.accessToken = sessionId;
                    Fetch.ekbCorpId = corporationId;
                    Fetch.staffSetting = staffSetting || { language: Fetch.defaultLanguage };
                    return [2, Promise.resolve()];
                case 2:
                    e_2 = _b.sent();
                    return [2, Promise.reject(e_2)];
                case 3: return [2];
            }
        });
    });
}
function dingTalkSession() {
    return __awaiter(this, void 0, void 0, function () {
        var params, result, _a, sessionId, corporationId, staffSetting, isAssistPlatform, e_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    params = {
                        dtCorpId: filter('corpId'),
                        accessToken: filter('token')
                    };
                    window.dtCorpId = filter('corpId');
                    return [4, Fetch.GET('/api/dingtalk/v2/session', params)];
                case 1:
                    result = _b.sent();
                    _a = result.value, sessionId = _a.sessionId, corporationId = _a.corporationId, staffSetting = _a.staffSetting, isAssistPlatform = _a.isAssistPlatform;
                    Fetch.isAssistPlatform = isAssistPlatform;
                    Fetch.accessToken = sessionId;
                    Fetch.ekbCorpId = corporationId;
                    Fetch.staffSetting = staffSetting || { language: Fetch.defaultLanguage };
                    return [2, Promise.resolve()];
                case 2:
                    e_3 = _b.sent();
                    return [2, Promise.reject(e_3)];
                case 3: return [2];
            }
        });
    });
}
function debuggerSession() {
    return __awaiter(this, void 0, void 0, function () {
        var params, result, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    params = {
                        accessToken: filter('token')
                    };
                    return [4, Fetch.GET('/api/account/v2/session', params)];
                case 1:
                    result = _a.sent();
                    Fetch.isAssistPlatform = result.value && result.value.isAssistPlatform;
                    Fetch.accessToken = result.value && result.value.id;
                    Fetch.corpId = filter('corpId');
                    Fetch.staffSetting = result.staffSetting || { language: Fetch.defaultLanguage };
                    return [2, Promise.resolve()];
                case 2:
                    e_4 = _a.sent();
                    return [2, Promise.reject(e_4)];
                case 3: return [2];
            }
        });
    });
}
